const ja = {
    path: '/ja',
    name: '日本語',
    shorthand: 'ja',
}
exports.ja = ja
